<template>
    <div class="container">
        <h1>Shipping Details</h1>
        <hr />
        <div class="form" v-if="shippingDetails">
            <div class="fields fields--2">
				<div>
					<label class="field">
						<span class="field__label" for="firstname">Name</span>
						<input 
							class="field__input" 
							type="text"
							maxLength="15"
							id="firstname" 
							v-model="shippingDetails.first_name" 
							@blur="$v.shippingDetails.first_name.$touch()"
							:class="{ active: !isActive}"
							/>
					</label>
					<template v-if="$v.shippingDetails.first_name.$error">
						<p v-if="!$v.shippingDetails.first_name.required" class="errorMessage">Name is required</p>
					</template>
					<template v-if="$v.shippingDetails.first_name.$error">
						<p v-if="!$v.shippingDetails.first_name.maxLength" class="errorMessage">Name is too long</p>
					</template>
					<template v-if="$v.shippingDetails.first_name.$error">
						<p v-if="!$v.shippingDetails.first_name.minLength" class="errorMessage">Name is too short</p>
					</template>					
				</div>
				<div>
					<label class="field">
						<span class="field__label" for="lastname">Surname</span>
						<input 
							class="field__input" 
							type="text" 
							id="lastname"
							maxLength="27"
							v-model="shippingDetails.last_name" 
							@blur="$v.shippingDetails.last_name.$touch()"
							:class="{ active: !isActive}"
							/>
					</label>
					<template v-if="$v.shippingDetails.last_name.$error">
						<p v-if="!$v.shippingDetails.last_name.required" class="errorMessage">Surname is required</p>
					</template>
					<template v-if="$v.shippingDetails.last_name.$error">
						<p v-if="!$v.shippingDetails.last_name.maxLength" class="errorMessage">Surname is too long</p>
					</template>
					<template v-if="$v.shippingDetails.last_name.$error">
						<p v-if="!$v.shippingDetails.last_name.minLength" class="errorMessage">Surname is too short</p>
					</template>			
				</div>
            </div>
			<div>
				<label class="field">
					<span class="field__label" for="address">Address</span>
					<input 
						class="field__input" 
						type="text" 
						ref="autocomplete" 
						id="address"
						maxLength="35"
						placeholder="  Enter location" 
						v-model="shippingDetails.address" 
						@blur="$v.shippingDetails.address.$touch()"
						:class="{ active: !isActive}"
						/>
				</label>
				<template v-if="$v.shippingDetails.address.$error">
					<p v-if="!$v.shippingDetails.address.required" class="errorMessage">Address is required</p>
				</template>				
			</div>


            <div class="fields fields--3">
				<div>
					<label class="field">
						<span class="field__label" for="zipcode">Zip code</span>
						<input 
							class="field__input" 
							type="text"
							minLength="3"
							maxLength="12"
							id="zipcode" 
							v-model="shippingDetails.zip_code" 
							@blur="$v.shippingDetails.zip_code.$touch()"
							:class="{ active: !isActive}"
							/>
					</label>
					<template v-if="$v.shippingDetails.zip_code.$error">
						<p v-if="!$v.shippingDetails.zip_code.required" class="errorMessage">Zip code is required</p>
                	</template>					
				</div>
				<div>
					<label class="field">
						<span class="field__label" for="city">City</span>
						<input 
							class="field__input" 
							type="text" 
							id="city"
							maxLength="20"
							v-model="shippingDetails.city" 
							@blur="$v.shippingDetails.city.$touch()"
							:class="{ active: !isActive}"
							/>
					</label>
					<template v-if="$v.shippingDetails.city.$error">
						<p v-if="!$v.shippingDetails.city.required" class="errorMessage">City is required</p>
					</template>					
				</div>
            </div>
            <div class="fields fields--2">
				<div>
					<label class="field">
						<span class="field__label" for="state">State<span class="field__label_optional"> (optional)</span></span>
						<input 
							class="field__input" 
							type="text"
							maxLength="20"
							id="state" 
							v-model="shippingDetails.state"
							/>
						<!-- <select class="field__input" id="state">
							<option value=""></option>
						</select> -->
					</label>					
				</div>
				<div>
					<label class="field">
						<span class="field__label" for="contact_no">Phone number</span>
						<input 
							class="field__input"
							oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							minLength="4"
							maxLength="13" 
							id="contact_no" 
							v-model="shippingDetails.contact_no" 
							@blur="$v.shippingDetails.contact_no.$touch()"/>
					</label>
					<template v-if="$v.shippingDetails.contact_no.$error">
						<p v-if="!$v.shippingDetails.contact_no.required" class="errorMessage">Phone number is required</p>
						<div v-else class="errorMessage">
							Please enter phone number starting with + and 11 or 12 digits
						</div>
					</template>
				</div>
            </div>
            <label class="field">
                <span class="field__label" for="country">Country</span>
                <country-select
					:country="shippingDetails.country" 
					v-model="shippingDetails.country"
					topCountry="SI"
					:countryName="true"
					:autocomplete="true"
					class="field__input" 
					id="country"
					@blur="$v.shippingDetails.country.$touch()"
					:class="{ active: !isActive}"
                />
            </label>
            <template v-if="$v.shippingDetails.country.$error">
				<p v-if="!$v.shippingDetails.country.required" class="errorMessage">Country is required</p>
            </template>
        </div>
        <hr>
		<label class="field">
                    <span class="field__label" for="contact_no">Leave a note<span class="field__label_optional"> (optional)</span></span>
                    <textarea 
						class="field__input" 
						type="text" 
						id="note"
						maxLength="150"
						v-model="shippingDetails.note"/>
                </label>
        <button :disabled="$v.$invalid" @click="saveShippingDetails">CHECK TOTAL PRICE AND EST. DELIVERY DATE</button>
    </div>
</template>

<script>
import { helpers, required, maxLength, minLength } from 'vuelidate/lib/validators'
import ShippingService from '@/services/ShippingService'
import countryLookup from 'country-code-lookup'

const contactNoRegex = helpers.regex('contact_no', /^([+][0-9]{11,12})$/)

export default {
    data() {
        return {
            isActive: false,
            shippingDetails: this.createFreshShippingObject(),
            widget: null,
			isValidPhoneNumber: true,
        }
    },
    validations: {
        shippingDetails: {
            first_name: { required, maxLength: maxLength(14), minLength: minLength(2) },
            last_name: { required, maxLength: maxLength(25), minLength: minLength(2) },
            address: { required },
            zip_code: { required },
            city: { required },
            contact_no: { required, contactNoRegex },
            country: { required }
        }
    },
    async mounted() {
        const shippingData = await this.$store.dispatch('account/fetchUserShippingDetails')
        if(shippingData.length !== 0) {
            this.shippingDetails = shippingData[0]
        }
        this.widget = new window.google.maps.places.Autocomplete(
        (this.$refs.autocomplete),
        {types: ['geocode']});
        this.widget.addListener('place_changed', () => {
            this.shippingDetails.zip_code = ''
            this.shippingDetails.city = ''
            this.shippingDetails.country = ''
            this.shippingDetails.state = ''
            this.shippingDetails.address = this.$refs.autocomplete.value;
            const placeDetails = this.widget.getPlace();
            placeDetails.address_components.forEach(addressComp => {
            	if(this.shippingDetails.city === '' && (addressComp.types.includes('locality') || addressComp.types.includes('postal_town'))) this.shippingDetails.city = addressComp.long_name;
				if(addressComp.types.includes('administrative_area_level_1')) this.shippingDetails.state = addressComp.long_name;
				if(addressComp.types.includes('postal_code')) this.shippingDetails.zip_code = addressComp.long_name;
				if(addressComp.types.includes('country')) this.shippingDetails.country = addressComp.long_name;
            });
        });
        },
    methods: {
        createFreshShippingObject() {
            return {
				first_name: '',
				last_name: '',
				address: '',
				zip_code: '',
				city: '',
				country: '',
				state: '',
				contact_no: ''
            }
        },
        async saveShippingDetails() {
            const validAddress = await this.validateAddress()
            if(validAddress) {
				await this.$store.dispatch('account/saveUserShippingDetails', this.shippingDetails)
				this.$emit('shipping-data', { data: this.shippingDetails })
				this.$emit('open-modal', {type: 'miniCart', flow: 'shippable'})
            } else {
            this.$notify({
				group: 'main',
				type: 'error',
				text: 'Please enter valid address'
            });
            }
        },
        async validateAddress() {
            const validationResponse = await ShippingService.getValidateAddress({
				StreetAddress: this.shippingDetails.address,
				City: this.shippingDetails.city,
				PostalCode: this.shippingDetails.zip_code,
				CountryCode: countryLookup.byCountry(this.shippingDetails.country).iso2
            })
            if(validationResponse.data.status === 'VALID') return true
            return false
        }
    }
}
</script>

<style lang="scss" scoped>

*,
*:before,
*:after {
	box-sizing: inherit;
}

html {
	font-size: 14px;
	box-sizing: border-box;
}

body {
	margin: 0;
}

h1 {
	margin: 0;
	font-size: 1.8em;
}

p {
	color: var(--bg);
}

hr {
	height: 1px;
	width: 100%;
	background-color: var(--grey);
	border: 0;
	margin: 1.5rem 0;
}

input::placeholder {
    font-weight: normal;
    opacity: 0.5;
	font-size: 0.8rem;
    color: var(--grey);
}

.inactive {
	background-color: var(--primarySuperLight);
	border-radius: 3.5px;
	font-style: italic;
}

.container {
	max-width: 40rem;
	padding: 2vw 0.5rem 0;
	margin: 0 auto;
	height: 100vh;
}

.form {
	display: grid;
	grid-gap: 1rem;
}

.field {
	width: 100%;
	display: flex;
	flex-direction: column;
	border: 1px solid var(--grey-superlight);
	padding: .5rem;
	border-radius: .25rem;
}

.field__label {
	color: var(--gray);
	font-size: 0.6rem;
	font-weight: 300;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	text-align: left;
}
.field__label_optional {
	color: var(--gray);
	font-size: 0.5rem;
	font-weight: 300;
	letter-spacing: 1px;
	text-align: right;
	margin-left: 5px;
	margin-bottom: 1px;
}

.field__input {
	padding: 0;
	margin: 0;
	border: 0;
	outline: 0;
	font-weight: bold;
	font-size: 1rem;
	width: 100%;
	-webkit-appearance: none;
	appearance: none;
	background-color: var(--grey-superlight);
}
.field:focus-within {
	border-color: #000;
}

.fields {
	display: grid;
	grid-gap: 1rem;
}
.fields--2 {
	grid-template-columns: 1fr 1fr;
}
.fields--3 {
	grid-template-columns: 1fr 2fr;
}

button {
	background: linear-gradient(to right, #fb7377, #c95c5f);
	text-transform: uppercase;
	font-size: 0.8rem;
	font-weight: 600;
	display: block;
	color: #fff;
	width: 100%;
	padding: 1rem;
	border-radius: 0.25rem;
	border: 0;
	cursor: pointer;
	outline: 0;
}
button:focus-visible {
	background-color: var(--bg);
}

button:disabled,
button[disabled]{
  border: 1px solid #999999 !important;
  background: #cccccc !important;
  color: #666666 !important;
  cursor: context-menu;
}

.errorMessage {
	font-size: 0.8em;
	margin-top: -5px;
	margin-left: 5px;
	color: var(--primaryDark);
	display: flex;
	text-align: left;
}

// media queries for common device breakpoints

//iPhone 5 //
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
.container {
	height: 200vh;
}
.field {
	margin: 0;
}
}
//iPhone 12Pro //
@media only screen and (min-device-width: 390px) and (max-device-width: 844px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
.container {
	height: 200vh;
}
}

/* ----------- Galaxy S4, S5 and Note 3 ----------- */

// // @media screen 
// //   and (device-width: 320px) 
// //   and (device-height: 640px) 
// //   and (-webkit-device-pixel-ratio: 3) 
// //   and (orientation: landscape) {
// // .container {
// //   height: 180vh;
// // }
// // .field {
// //   margin: 0;
// // }
// // }

/* ----------- Galaxy S6 ----------- */

// @media screen 
//   and (device-width: 320px) 
//   and (device-height: 640px) 
//   and (-webkit-device-pixel-ratio: 4) 
//   and (orientation: landscape) {
// .container {
//   height: 180vh;
// }
// .field {
//   margin: 0;
// }
// }

//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
.container {
  height: 200vh;
}
.field {
  margin: 5px;
}
}

//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
.container {
	height: 185vh;
}
.field {
	margin: 5px;
}
}



</style>

<style>
/* global styles */
.pac-container {
    z-index: 1042 !important;
}
</style>